<!-- 统计卡片组件 -->
<template>
  <div class="stats-cards" v-loading="loading">
    <el-row :gutter="20">
      <!-- 工单总量 -->
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon">
              <i class="el-icon-document"></i>
            </div>
            <div class="card-title">工单总量</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ statsData.totalWorkOrders || 0 }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.totalWorkOrdersRate)">
              <i :class="getTrendIcon(statsData.totalWorkOrdersRate)"></i>
              <span>{{ formatRate(statsData.totalWorkOrdersRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>

      <!-- 完成率 -->
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon success">
              <i class="el-icon-check"></i>
            </div>
            <div class="card-title">完成率</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ formatPercentage(statsData.overallCompletionRate) }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.overallCompletionRateRate)">
              <i :class="getTrendIcon(statsData.overallCompletionRateRate)"></i>
              <span>{{ formatRate(statsData.overallCompletionRateRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>

      <!-- 平均处理时长 -->
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon warning">
              <i class="el-icon-time"></i>
            </div>
            <div class="card-title">平均处理时长</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ formatHours(statsData.avgProcessingHours) }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.avgProcessingHoursRate)">
              <i :class="getTrendIcon(statsData.avgProcessingHoursRate)"></i>
              <span>{{ formatRate(statsData.avgProcessingHoursRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px;">
      <!-- 超时工单数 -->
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon danger">
              <i class="el-icon-warning"></i>
            </div>
            <div class="card-title">超时工单数</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ statsData.inspectionTimeoutCount || 0 }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.inspectionTimeoutCountRate)">
              <i :class="getTrendIcon(statsData.inspectionTimeoutCountRate)"></i>
              <span>{{ formatRate(statsData.inspectionTimeoutCountRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>

      <!-- 巡检完成量 -->
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon info">
              <i class="el-icon-search"></i>
            </div>
            <div class="card-title">巡检完成量</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ statsData.inspectionCompletedCount || 0 }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.inspectionCompletedCountRate)">
              <i :class="getTrendIcon(statsData.inspectionCompletedCountRate)"></i>
              <span>{{ formatRate(statsData.inspectionCompletedCountRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>

      <!-- 维修完成量 -->
      <el-col :span="8">
        <div class="stats-card">
          <div class="card-header">
            <div class="card-icon primary">
              <i class="el-icon-setting"></i>
            </div>
            <div class="card-title">维修完成量</div>
          </div>
          <div class="card-content">
            <div class="card-value">{{ statsData.repairCompletedCount || 0 }}</div>
            <div class="card-trend" :class="getTrendClass(statsData.repairCompletedCountRate)">
              <i :class="getTrendIcon(statsData.repairCompletedCountRate)"></i>
              <span>{{ formatRate(statsData.repairCompletedCountRate) }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'StatsCards',
  props: {
    statsData: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 获取趋势样式类
    getTrendClass(rate) {
      if (!rate) return '';
      return rate > 0 ? 'trend-up' : 'trend-down';
    },

    // 获取趋势图标
    getTrendIcon(rate) {
      if (!rate) return '';
      return rate > 0 ? 'el-icon-top' : 'el-icon-bottom';
    },

    // 格式化比率
    formatRate(rate) {
      if (!rate) return '';
      const sign = rate > 0 ? '+' : '';
      return `${sign}${rate}%`;
    },

    // 格式化百分比
    formatPercentage(value) {
      if (!value) return '0%';
      return `${value}%`;
    },

    // 格式化小时
    formatHours(value) {
      if (!value) return '0h';
      return `${value}h`;
    }
  }
};
</script>

<style lang="scss" scoped>
.stats-cards {
  margin-bottom: 20px;

  .stats-card {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    min-height: 110px;

    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }

    .card-header {
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      .card-icon {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        background-color: #f0f9ff;
        color: #409eff;

        &.success {
          background-color: #f0f9ff;
          color: #67c23a;
        }

        &.warning {
          background-color: #fdf6ec;
          color: #e6a23c;
        }

        &.danger {
          background-color: #fef0f0;
          color: #f56c6c;
        }

        &.info {
          background-color: #f4f4f5;
          color: #909399;
        }

        &.primary {
          background-color: #f0f9ff;
          color: #409eff;
        }

        i {
          font-size: 20px;
        }
      }

      .card-title {
        font-size: 14px;
        color: #606266;
        font-weight: 500;
      }
    }

    .card-content {
      .card-value {
        font-size: 28px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 8px;
        line-height: 1;
      }

      .card-trend {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: 500;

        i {
          margin-right: 4px;
          font-size: 12px;
        }

        &.trend-up {
          color: #67c23a;
        }

        &.trend-down {
          color: #f56c6c;
        }
      }
    }
  }
}
</style>
